/** Detect phone/tablet browsers — use mobile-safe XLSX write options. */
export function isMobileExportDevice() {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}

const MOBILE_FONT = 'Calibri';

/** Android Excel reads Calibri/Arial styled cells more reliably than Segoe UI. */
export function applyMobileWorkbookFonts(workbook) {
  (workbook.worksheets || []).forEach((sheet) => {
    sheet.eachRow({ includeEmpty: false }, (row) => {
      row.eachCell({ includeEmpty: false }, (cell) => {
        const font = cell.font || {};
        cell.font = { ...font, name: MOBILE_FONT };
      });
    });
  });
}

export function applyMobileSheetFreeze(sheet, headerRow, { colSplit = 2 } = {}) {
  if (!headerRow || headerRow < 1) return;
  sheet.views = [{
    state: 'frozen',
    xSplit: colSplit,
    ySplit: headerRow,
    topLeftCell: sheet.getCell(headerRow + 1, colSplit + 1).address,
    activeCell: sheet.getCell(headerRow + 1, colSplit + 1).address,
    showGridLines: true,
    zoomScale: 100,
  }];
}
